import React from 'react';
import { useNavigate } from 'react-router-dom';
import './css/Daily.css';

const InDevelopment = () => {
    const navigate = useNavigate();

    return (
        <div className="wrapper supportScreen">
            <div className="supportSurface">
                <div className="supportHeader">
                    <h2 className="dailyMainTitle">Making improvements</h2>
                    <p className="inDevelopmentCopy">
                        In development. Please check back soon.
                    </p>
                </div>

                <div className="supportSectionCard">
                    <h5 className="supportSectionTitle">Thanks for your patience</h5>
                    <p className="inDevelopmentCopy inDevelopmentCopy--card">
                        We are building a better experience across Trampoline Health. If you need help or have any questions in the meantime, reach out to us through our Support Email. Linked in our Support tab.
                    </p>
                    <div className="homeBttnContainer supportActions">
                        <button
                            type="button"
                            className="homeBttn"
                            onClick={() => navigate(-1)}
                        >
                            Go back
                        </button>
                        {/* <button
                            type="button"
                            className="homeBttn"
                            onClick={() => navigate('/support')}
                        >
                            Support
                        </button> */}
                    </div>
                </div>
            </div>
        </div>
    );
};


export default InDevelopment;